export const foodIndustryKeys = [
    'ready-meals-soups',
    'bakery-products',
    'animal-food',
    'confectionery-ice-cream',
    'pasta-rice',
    'snacks',
    'breakfast-muesli',
    'baby-food',
    'ingredients-sauces-seasonings',
    'supplements-tobacco',
    'storable-food-and-beverages',
    'drinks',
    'meat-sausages',
    'fish-seafood',
    'dairy-products',
    'fruit-vegetables',
    'fresh-ready-meals',
    'frozen-food',
    'nutrition-supplements',
    'spices-tea-cereals'
];

export const logisticsKeys = [
    'courier-express-parcel-postal',
    'warehousing',
    'e-commerce',
    'shipping'
];

export const manufacturingKeys = [
    'building-materials-dry-bulk',
    'pharma',
    'chemical-petrochemical-pharmaceutical',
    'paints-varnishes',
    'electrical-products',
    'mechanical-engineering',
    'metalworking',
    'plant-engineering',
    'vehicle-manufacturing'
];

export const retailKeys = [
    'bakery',
    'butcher',
    'milk-cheese',
    'fruit-vegetables',
    'supermarket',
    'unpacked-store',
    'deli'
];

export const foodcraftsKeys = [
    'farm-shop',
    'market-stall',
    'deli',
    'unpacked-store',
    'fruit-vegetables',
    'smaller-grocery-stores',
    'milk-cheese',
    'butcher',
    'bakery'
];

export const gastronomyKeys = ['kitchen-catering', 'restaurant-hotel'];
